"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledRow = (0, _styledComponents.default)(({
  noGutters,
  children,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...otherProps,
  children: children
}))`
    box-sizing: border-box;
    display: flex;
    margin-right: ${({
  theme
}) => `calc(${theme.gridGutterWidth} * -0.5)`};
    margin-left: ${({
  theme
}) => `calc(${theme.gridGutterWidth} * -0.5)`};
    flex-wrap: wrap;
    list-style: none;

    ${props => props.noGutters && (0, _styledComponents.css)`
        margin-right: 0;
        margin-left: 0;

        & > div {
            padding-right: 0;
            padding-left: 0;
        }
    `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
var _default = StyledRow;
exports.default = _default;